import { AppConfig } from './types';

/**
 * Production environment configuration
 * Only specify values that differ from the default configuration
 */
export const productionConfig: Partial<AppConfig> = {
  proctoring: {
    api: {
      baseUrl: 'https://api.smarterproctoring.com',
      timeout: 30000,
      retryAttempts: 3
    }
  },
  assessment: {
    api: {
      baseUrl: '',
      timeout: 30000,
      retryAttempts: 3
    }
  },
  core : {
    api: {
      baseUrl: 'https://signon.smarterproctoring.com',
      timeout: 30000,
      retryAttempts: 3
    }
  },
  media : {
    api: {
      baseUrl: 'https://api.proctoring.media',
      timeout: 30000,
      retryAttempts: 3
    },
    playback: {
      baseUrl: 'https://playback.proctoring.media',
    },
    livekit: {
      websocketUrl: 'wss://proctoring.media',
    }
  },
  elements: {
    ui : {
      baseUrl: 'https://app.smarterservices.com',
    }
  }
};
